import { TypographySmall } from '@talentmesh/ui/components/typography';
import { useTeamMembersContext } from '../../Context/TeamMembersContext';
import ConfirmationDialog from './ConfirmationDialog';
import { useNotificationContext } from '@/Context/NotificationContext';
import UIStrings from '@/Utils/UIStrings';

const TeamMemberRemoveDialog = () => {
    const { removeMember, activeDialog, closeDialog, selectedMember } = useTeamMembersContext();
    const { showFailToaster } = useNotificationContext();

    const handleClose = () => closeDialog();
    const handleConfirm = async () => {
        try {
            await removeMember(selectedMember!);
            handleClose();
        } catch (e) {
            showFailToaster();
        }
    };

    return (
        <ConfirmationDialog
            open={activeDialog === 'RemoveAccessConfirmation'}
            title={UIStrings.RemoveMemberAccess}
            actionButtonText={UIStrings.RemoveAccess}
            onClose={handleClose}
            onConfirm={handleConfirm}
        >
            <div>
                <TypographySmall>{`${UIStrings.AreYouSureYouWantToRemoveTheAccessForMemberName} `}</TypographySmall>
                <TypographySmall className="font-bold">{`${selectedMember?.firstName} ${selectedMember?.lastName}`}</TypographySmall>
            </div>
        </ConfirmationDialog>
    );
};

export default TeamMemberRemoveDialog;
